export const saveToLocalStorage = (key, value) => {
    // valueがオブジェクトの場合はJSON形式に変換
    if (typeof value === 'object') {
        value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
}
